import React, { useState, useEffect } from 'react';
import './HrDashboard.css';
import axios from 'axios';
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.request.use((config) => {

  const token = localStorage.getItem('authToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

const Dashboard = () => {
  const [pendingLeaves, setPendingLeaves] = useState([]);
  const [loadingLeaves, setLoadingLeaves] = useState(false);
  const [leaveError, setLeaveError] = useState('');

  const [totalEmployees, setTotalEmployees] = useState(null);
  const [activeUsers, setActiveUsers] = useState(null);

  const fetchUserStats = async () => {
    try {
      const [allRes, activeRes] = await Promise.all([
        api.get('/admin/users'),
        api.get('/admin/users/active'),
      ]);
      setTotalEmployees(allRes.data.length);
      setActiveUsers(activeRes.data.length);
    } catch (err) {
      console.error('Error fetching user stats:', err);
    }
  };

  const fetchPendingLeaves = async () => {

    try {

      setLoadingLeaves(true);

      const response = await api.get('/leave/pending');

      console.log("Pending Leaves:", response.data);

      setPendingLeaves(response.data);

    } catch (error) {

      console.error(
        "Error fetching pending leaves:",
        error
      );

      setLeaveError(
        'Failed to fetch pending leave requests.'
      );

    } finally {

      setLoadingLeaves(false);

    }
  };

  useEffect(() => {
    fetchUserStats();
    fetchPendingLeaves();
  }, []);
  return (

    <div className="hr-content animate-fade-in">

      <div className="dashboard-stats">
        <div className="stat-card primary">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <div className="stat-value">
              {totalEmployees !== null ? totalEmployees : '—'}
            </div>
            <div className="stat-label">Total Employees</div>
          </div>
        </div>

        <div className="stat-card success">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <div className="stat-value">
              {activeUsers !== null ? activeUsers : '—'}
            </div>
            <div className="stat-label">Active Users</div>
          </div>
        </div>

        <div className="stat-card warning">
          <div className="stat-icon">⏱️</div>
          <div className="stat-content">
            <div className="stat-value">5</div>
            <div className="stat-label">Late Arrivals</div>
          </div>
        </div>

        <div className="stat-card info">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <div className="stat-value">2</div>
            <div className="stat-label">New Hires</div>
          </div>
        </div>
      </div>

      <div className="dashboard-cards">
        <div className="card">
          <div className="card-header">
            <h3>Pending Approvals</h3>
            <span className="card-badge">10</span>
          </div>
          <div className="card-content">
            <div className="approval-item">
              <div className="approval-info">
                <div className="approval-type">
                  Leave Requests
                </div>

                <div className="approval-meta">
                  {loadingLeaves
                    ? 'Loading...'
                    : `${pendingLeaves.length} pending`}
                </div>
              </div>

              <div className="approval-count">
                {loadingLeaves ? '...' : pendingLeaves.length}
              </div>
            </div>
            <div className="approval-item">
              <div className="approval-info">
                <div className="approval-type">Expenses</div>
                <div className="approval-meta">5 pending</div>
              </div>
              <div className="approval-count">5</div>
            </div>
            <div className="approval-item">
              <div className="approval-info">
                <div className="approval-type">New Hires</div>
                <div className="approval-meta">2 pending</div>
              </div>
              <div className="approval-count">2</div>
            </div>
          </div>
          <div className="card-footer">

            <button
              className="card-action"
              onClick={() =>
                window.location.href =
                '/hr/all-leaves'
              }
            >
              View All Approvals
            </button>

          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Payroll Status</h3>
            <span className="card-status">On Track</span>
          </div>
          <div className="card-content">
            <div className="payroll-info">
              <div className="payroll-label">Next Payday:</div>
              <div className="payroll-value highlight">Apr 30</div>
            </div>
            <div className="payroll-info">
              <div className="payroll-label">Last Paid:</div>
              <div className="payroll-value">$6,200</div>
            </div>
            <div className="payroll-info">
              <div className="payroll-label">Days Until Payday:</div>
              <div className="payroll-value highlight">5 days</div>
            </div>
          </div>
          <div className="card-footer">
            <button className="card-action">Manage Payroll</button>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Hiring Pipeline</h3>
            <span className="card-badge">12 Open</span>
          </div>
          <div className="card-content">
            <div className="pipeline-chart">
              <div className="pipeline-stage">
                <div className="pipeline-label">Open Positions</div>
                <div className="pipeline-bar">
                  <div className="pipeline-fill" style={{ width: '100%' }}></div>
                </div>
                <div className="pipeline-value">12</div>
              </div>
              <div className="pipeline-stage">
                <div className="pipeline-label">Applicants</div>
                <div className="pipeline-bar">
                  <div className="pipeline-fill" style={{ width: '75%' }}></div>
                </div>
                <div className="pipeline-value">9</div>
              </div>
              <div className="pipeline-stage">
                <div className="pipeline-label">Interviews</div>
                <div className="pipeline-bar">
                  <div className="pipeline-fill" style={{ width: '58%' }}></div>
                </div>
                <div className="pipeline-value">7</div>
              </div>
              <div className="pipeline-stage">
                <div className="pipeline-label">Hired</div>
                <div className="pipeline-bar">
                  <div className="pipeline-fill" style={{ width: '25%' }}></div>
                </div>
                <div className="pipeline-value">3</div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="card-action">View Pipeline</button>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Quick Actions</h3>
          </div>
          <div className="card-content">
            <div className="quick-links">
              <button className="quick-link-btn primary">
                <span className="btn-icon">➕</span>
                Add Employee
              </button>
              <button className="quick-link-btn success">
                <span className="btn-icon">💰</span>
                Run Payroll
              </button>
              <button
                className="quick-link-btn info"
                onClick={() =>
                  window.location.href =
                  '/hr/leave-approvals'
                }
              >
                <span className="btn-icon">✅</span>
                Approve Leave
              </button>
              <button className="quick-link-btn warning">
                <span className="btn-icon">📝</span>
                Create Report
              </button>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Recent Activity</h3>
          </div>
          <div className="card-content">
            <div className="activity-list">
              <div className="activity-item">
                <div className="activity-icon">👤</div>
                <div className="activity-details">
                  <div className="activity-title">New employee onboarded</div>
                  <div className="activity-time">2 hours ago</div>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">📅</div>
                <div className="activity-details">
                  <div className="activity-title">Leave request approved</div>
                  <div className="activity-time">4 hours ago</div>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">💳</div>
                <div className="activity-details">
                  <div className="activity-title">Expense report submitted</div>
                  <div className="activity-time">Yesterday</div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="card-action">View All Activity</button>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Upcoming Events</h3>
          </div>
          <div className="card-content">
            <div className="event-list">
              <div className="event-item">
                <div className="event-date">
                  <div className="event-day">15</div>
                  <div className="event-month">MAY</div>
                </div>
                <div className="event-details">
                  <div className="event-title">Team Building Event</div>
                  <div className="event-time">10:00 AM - 2:00 PM</div>
                </div>
              </div>
              <div className="event-item">
                <div className="event-date">
                  <div className="event-day">22</div>
                  <div className="event-month">MAY</div>
                </div>
                <div className="event-details">
                  <div className="event-title">Quarterly Review</div>
                  <div className="event-time">1:00 PM - 4:00 PM</div>
                </div>
              </div>
              <div className="event-item">
                <div className="event-date">
                  <div className="event-day">05</div>
                  <div className="event-month">JUN</div>
                </div>
                <div className="event-details">
                  <div className="event-title">Benefits Enrollment</div>
                  <div className="event-time">All Day</div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="card-action">View Calendar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

